var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "36px",
    viewBox: "0 0 27 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-file copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000104606113 34.6534653 26.8245988 34.6534653 26.8245988 0.0853168317 0.000104606113 0.0853168317"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-file-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped",
    transform: "translate(0.000000, 0.261218)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1432643,8.14848515 L21.7968803,8.14848515 L19.3721106,8.14848515 C18.9958773,8.14848515 18.6907762,7.8459604 18.6907762,7.47308911 L18.6907762,0.760712871 C18.6907762,0.758633663 18.6907762,0.75690099 18.6907762,0.754821782 L18.6907762,0.0853168317 L0.681439087,0.0853168317 C0.305205768,0.0853168317 0.000104606113,0.387841584 0.000104606113,0.760712871 L0.000104606113,33.9777921 C0.000104606113,34.3510099 0.305205768,34.6535347 0.681439087,34.6535347 L26.1432643,34.6535347 C26.5194976,34.6535347 26.8245988,34.3510099 26.8245988,33.9777921 L26.8245988,8.14848515 L26.1432643,8.14848515 Z",
    id: "Fill-1",
    fill: "#D9E8FB",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#D9E8FB",
    fillRule: "nonzero",
    points: "20.0535497 0.742242574 20.0535497 7.05887624 26.4254567 7.05887624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5969129,17.9090909 L13.5969129,20.0909091 L15.1061856,20.0909091 C15.4970127,20.0909157 15.8332651,20.3673321 15.9088902,20.7507727 L15.9088902,20.7507727 L17.0882311,26.7304545 C17.5242538,28.9414545 15.8320493,31 13.5785038,31 C11.3171856,31 9.62320834,28.9280227 10.0725947,26.7117727 L10.0725947,26.7117727 L11.4150947,20.0909091 L11.4150947,17.9090909 L13.5969129,17.9090909 Z M13.5969129,13.5454545 L13.5969129,15.7272727 L11.4150947,15.7272727 L11.4150947,13.5454545 L13.5969129,13.5454545 Z M15.7787311,11.3636364 L15.7787311,13.5454545 L13.5969129,13.5454545 L13.5969129,11.3636364 L15.7787311,11.3636364 Z M13.5969129,9.18181818 L13.5969129,11.3636364 L11.4150947,11.3636364 L11.4150947,9.18181818 L13.5969129,9.18181818 Z M15.7787311,7 L15.7787311,9.18181818 L13.5969129,9.18181818 L13.5969129,7 L15.7787311,7 Z",
    id: "Combined-Shape",
    fill: "#8B91A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon-archive.5b8e56439f410dda58f9af1ad3ffd25e.svg";
export { ForwardRef as ReactComponent };